import * as api from '../api/brand';
import * as types from './mutation-types';
export const getBrandBase = ({dispatch}, brandId) => {
  api.getBrandBase(brandId).then((data) => {
    dispatch(types.RECEIVE_INTRO, data.baseShow);
  });
};

export const getBrandCoupons = ({dispatch}, options) => {
  api.getCouponList(options).then((list, shopIds) => {
    dispatch(types.RECEIVE_COUPONS, list, shopIds)
  }).catch(e => {
    console.log(e);
  })
};

export const getBrandEnvironment = ({dispatch}, brandId) => {
  api.getBrandEnvironment(brandId).then((data) => {
    dispatch(types.RECEIVE_ENVIRONMENT, data.climateInfos);
  });
};

export const getBrandFeature = ({dispatch}, brandId, featureId) => {

  if (featureId) {
    api.getBrandFeatureContent(brandId, featureId).then((data) => {
      dispatch(types.RECEIVE_FEATURE_CONTENT, data.specialInfo);
    });
  } else {
    api.getBrandFeature(brandId).then((data) => {
      dispatch(types.RECEIVE_FEATURE, data.specialsList);
    });
  }

};


export const getBrandBranch = ({dispatch}, brandId, lat, lng, cityId, env, isAll) => {

  if (isAll) {
    api.getBrandBranchAll(brandId, lat, lng, cityId, env).then((data) => {
      dispatch(types.RECEIVE_BRANCH_ALL, data.shopDealGroups);
    });
  } else {
    api.getBrandBranchTop(brandId, lat, lng, cityId, env).then((data) => {
      dispatch(types.RECEIVE_BRANCH, data.topBrandShopList);
    });
  }

};

export const getBrandLecture = ({dispatch}, brandId, lectureId) => {

  if (lectureId) {
    api.getBrandLectureContent(brandId, lectureId).then((data) => {
      dispatch(types.RECEIVE_LECTURE_CONTENT, data.classroomDetail);
    });
  } else {
    api.getBrandLecture(brandId).then((data) => {
      dispatch(types.RECEIVE_LECTURE, data.classroom);
    });
  }
};

export const getBrandDetail = ({dispatch}, brandId) => {
  api.getBrandDetail(brandId).then((data) => {
    dispatch(types.RECEIVE_DETAIL, data.brandIntroduction);
  });
};

export const getBrandFollow = ({dispatch}, brandId, env, token) => {
  api.getBrandFollow(brandId, env, token).then((data, code) => {
    dispatch(types.CHECK_FOLLOW, data);
    dispatch(types.SET_LOGIN, true);
    dispatch(types.SEND_FOLLOW, false);
    dispatch(types.ADD_FANS_COUNT);
  }, (data) => {
    dispatch(types.CHECK_FOLLOW, data);
    // dispatch(types.SET_LOGIN, false);
    dispatch(types.SEND_FOLLOW, false);
  });
};

export const resetBrandFollow = ({dispatch}) => {
  dispatch(types.SEND_FOLLOW, true);
  dispatch(types.ERROR_FOLLOW, 0);
};


export const setLogin = ({dispatch}, status) => {
  dispatch(types.SET_LOGIN, status);
};

export const checkBrandFollow = ({dispatch}, brandId, env) => {
  api.checkBrandFollow(brandId, env).then((data, code) => {
    dispatch(types.CHECK_FOLLOW, data.hasStar);
    dispatch(types.SET_LOGIN, true);
  }, (data, code) => {

    dispatch(types.SET_LOGIN, false);
    dispatch(types.CHECK_FOLLOW, false);
  });
};



// WEBPACK FOOTER //
// ./src/vuex/actions.js